<template>
    <a
        v-if="email"
        :href="`mailto:${email}`"
        class="text-md block truncate overflow-hidden text-ellipsis text-(--link-default) underline hover:text-(--link-hover)"
        :class="linkClass"
        @click.stop
    >
        {{ displayEmail }}
    </a>
    <span v-else>-</span>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(
    defineProps<{
        email?: string | null;
        maxLength?: number;
        linkClass?: string;
    }>(),
    {
        maxLength: 0,
    },
);

const displayEmail = computed(() => {
    if (!props.email) return '';

    if (props.maxLength && props.email.length > props.maxLength) {
        return props.email.substring(0, props.maxLength) + '...';
    }

    return props.email;
});
</script>
